import { DatePipe } from '@angular/common';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { AppMainService } from './../../../app-main.service';
import { AppMainComponent } from './../../../app.main.component';
import { ConfigurationService } from './../../configurationService';
import { Component, OnInit } from '@angular/core';
import { NotificationConfigService } from '../services/notification-config.service';
import { workspaceModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { TimeOption } from 'src/app/misc/workspace/models/workbook-reminder.models';
import { timeStamp } from 'console';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationValidator } from './customValidators/notification-validator';
import { PermissionService } from 'src/app/service/permission.service';

@Component({
  selector: 'app-system-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class SystemNotificationComponent implements OnInit {

  configMenuNotificationItems;
  addEditNotificationHeader: string;
  loading: boolean;

  tempNofi;
  tempNofiChild = {
    id: 0,
    eventName: '',
    eventTypeId:0,
    channels:[],
    isActive:false,
    isDisplay:true,
    isEmail:true,
    isPushNotification:true,
    isRowUpdated:true,
    isSMS:true,
    isWhatsApp:true,
    showEmail:true,
    showPushNotification:true,
    showSMS:true,
    showWhatsApp:true,
    schedule: null,
    emailPreference: '',
    hour: 0,
    minute: 0,
    period: '',

  }
  allNotification;
  allModules = [];
  displayAddEditNotification = false;
  allChannels = [];
  selectedChannel = [];

  displayNotificationList = false;
  selectedLists = [];

  emailOptions = [
    { label: 'Immediate Email', value: 'immediateEmail' },
    { label: 'Daily Summary Email', value: 'dailySummaryEmail' }
  ];

  periodOptions = [
    { label: 'AM', value: 'AM' },
    { label: 'PM', value: 'PM' }
];

  hourOptions: TimeOption[] = [];
  minuteOptions: TimeOption[] = [];
  userPermissions: any[] = [];

  workSpaceModuleId = workspaceModuleId;
  isSubmitted: boolean = false;

  preferenceMap = {
    'immediateEmail': { label: 'Immediate Email', severity: 'danger' },
    'dailySummaryEmail': { label: 'Daily Summary', severity: 'info' },
    'weeklySummaryEmail': { label: 'Weekly Summary', severity: 'warning' },
    'monthlySummaryEmail': { label: 'Monthly Summary', severity: 'success' }
  };
  
  notificationForm: FormGroup;

  constructor(
    private notificationService: NotificationConfigService,
    public app: AppMainComponent,
    private messageService: MessageService,
    public datepipe: DatePipe,
    private fb: FormBuilder,
    private permissionService:PermissionService

  ) {
    this.generateTimeOptions();

  }

  ngOnInit(): void {
    this.userPermissions = this.permissionService.getPemrissionData();
    this.configMenuNotificationItems = [
        {
            label: "Notification",
            icon: 'pi pi-plus',
            command: () => {
              this.showNotificationList();
            }
        }
    ];
    this.loading = true;
  }

  inItNotificationForm(){
   this.notificationForm = this.fb.group({
      isActive: [true],
      isPushNotification: [false],
      isSMS: [false],
      isWhatsApp: [false],
      isEmail: [false],
      selectedChannels: [null],
      emailPreference: [''],
      hour: [0],
      minute: [0],
      period: ['']
    },
    { validators: NotificationValidator.atLeastOneNotificationRequired() } )
  }

  loadNotification(event: LazyLoadEvent){
    this.loading = true;
    setTimeout(() => {
      this.getNotification();
      this.loading = false;
    }, 1000);
  }
  getNotification(){
    this.notificationService.fetchNotificationData(this.app.userId,this.app.companyId).then(configs => {
      this.allNotification = configs;
      this.allModules = configs.modules;
      const permittedModuleIds = this.userPermissions
      .filter(p =>
        p.permissions.some(permission => permission.statusId === 1)
      )
      .map(p => p.objectId);
    const filteredNotificationData = this.allModules.filter(module =>
      permittedModuleIds.includes(module.moduleId)
    );
    this.allModules= filteredNotificationData;
    });
  }

  showEditNotificationChannel(s, data) {
    this.tempNofi = JSON.parse(JSON.stringify(data));
    this.tempNofiChild = JSON.parse(JSON.stringify(s));

    console.log(this.tempNofiChild);
    this.addEditNotificationHeader = "Edit Notification";
    if (!this.tempNofi?.schedule) {
      this.tempNofiChild.emailPreference = this.emailOptions[0].value;
    }

    this.getModuleChannels(s, data);
    this.displayAddEditNotification = true;
  }

  getModuleChannels(child,module){
    this.notificationService.getModuleChannels().then(allModuleChannels => {
      for(let s of allModuleChannels){
        if(s.name == module.moduleName){
          this.allChannels = s.channels;
          let arr = [];
          for(let c of child.channels){
            for(let channel of this.allChannels){
              if(channel.idvalue == c.channelId){
                arr.push(channel)
              }
            }
          }
          this.selectedChannel = JSON.parse(JSON.stringify(arr));
        }
      }
    });
    
  }
  saveNotification(){
    let channels = [];
    for(let s of this.selectedChannel){
      let eachChannel = {
        "channelId": s.idvalue,
        "channelName": s.channelname
      }
      channels.push(eachChannel)
    }
    
    this.tempNofiChild.channels = JSON.parse(JSON.stringify(channels));
    this.tempNofiChild.isRowUpdated = true;

    let arr = [];
    for(let s of this.tempNofi.subscription){
      if(s.id == this.tempNofiChild.id){
        arr.push(this.tempNofiChild)
      } else {
        arr.push(s)
      }
    }
    this.tempNofi.subscription = JSON.parse(JSON.stringify(arr));
    let arr2 = [];
    for(let s of this.allModules){
      if(s.moduleId == this.tempNofi.moduleId){
        arr2.push(this.tempNofi);
      } else {
        arr2.push(s);
      }
    }
    this.allModules = JSON.parse(JSON.stringify(arr2));
    this.allNotification.modules = JSON.parse(JSON.stringify(this.allModules));

    this.notificationService.updateNotificationData(this.allNotification).then((response) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Fields updated successfully...'
      });
      this.getNotification();
      this.displayAddEditNotification = false;
    }, (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error ? error?.error : 'Try again later...' });
    });

  }

  showNotificationList(){
    this.displayNotificationList = true;
  }
  addNotification(){
    for(let s of this.selectedLists){
      for(let c of this.allModules){
        for(let m of c.subscription){
          if(m.id == s.id){
            m.isActive = true;
          }
        }
      }
    }
    this.allNotification.modules = JSON.parse(JSON.stringify(this.allModules));
    this.notificationService.updateNotificationData(this.allNotification).then((response) => {
      this.displayNotificationList = false;
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Fields updated successfully...'
      });
      this.getNotification();
    }, (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error ? error?.error : 'Try again later...' });
    });
  }

  private generateTimeOptions() {
    // Generate once and memoize
    if (!this.hourOptions.length) {
      this.hourOptions = Array.from({ length: 12 }, (_, i) => ({
        label: (i + 1).toString().padStart(2, '0'),
        value: i + 1
      }));
    }

    if (!this.minuteOptions.length) {
      this.minuteOptions = [0, 15, 30, 45].map(m => ({
        label: m.toString().padStart(2, '0'),
        value: m
      }));
    }
  }

  private getDefaultDateTime(): Date {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(8, 0, 0); // Set to 8:00:00 AM
    return tomorrow; // Return local time directly
  }

  onMinuteInput(event: any): void {
    const inputValue = event.filter.replace(/[^0-9]/g, '');
    const numValue = Math.min(Math.max(parseInt(inputValue) || 0, 0), 59);

    // this.reminderForm.patchValue({
    //     minute: numValue
    // }, { emitEvent: false }); // Prevent unnecessary validation

    // Update options only if needed
    if (!this.minuteOptions.some(opt => opt.value === numValue)) {
      const newOption = {
        label: numValue.toString().padStart(2, '0'),
        value: numValue
      };
      this.minuteOptions = [...this.minuteOptions, newOption]
        .sort((a, b) => a.value - b.value);
    }
  }

  validateMinuteInput(event: any): boolean {
    const pattern = /^[0-9]$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    const currentValue = event.target.value || '';
    const newValue = currentValue + inputChar;
    if (parseInt(newValue) > 59) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  displayEmailPreferenceDialog: boolean = false;
  onEmailPreferenceChange() {
    // If the preference is changed but not set to dailySummaryEmail, reset time values
    this.displayEmailPreferenceDialog = this.tempNofiChild.isEmail;
    if (this.tempNofiChild.emailPreference !== 'dailySummaryEmail') {
      this.tempNofiChild.hour = null;
      this.tempNofiChild.minute = null;
      this.tempNofiChild.period = null;
    }
  }

  onEmailCheckboxChange($event: any) {
    const checked = !!$event?.checked;
    this.displayEmailPreferenceDialog = checked;

  }
  validateAndSaveNotification() {
    this.isSubmitted = true;
    if (this.tempNofi.moduleId === this.workSpaceModuleId) {
      if (this.tempNofiChild.isEmail && !this.tempNofiChild.emailPreference) {
        return;
      }

      // Check if daily summary email is selected and time fields are required
      if (this.tempNofiChild.isEmail &&
        this.tempNofiChild.emailPreference === 'dailySummaryEmail' &&
        (!this.tempNofiChild.hour || !this.tempNofiChild.minute || !this.tempNofiChild.period)) {
        return;
      }
    }

    // If all validations pass, call the original save method
    this.saveNotification();
  }


  cancelEmailPreferenceDialog() {
    this.displayEmailPreferenceDialog = false;
  }

  confirmEmailPreferenceDialog() {
    this.displayEmailPreferenceDialog = false;
  }

  getEmailPreferenceLabel(): string {
    const option = this.emailOptions.find(opt => opt.value === this.tempNofiChild.emailPreference);
    return option ? option.label : '';
  }
 
  formatTimeDisplay(): string {
    if (!this.tempNofiChild.hour || !this.tempNofiChild.minute || !this.tempNofiChild.period) {
      return '';
    }
    
    const hour = this.tempNofiChild.hour.toString().padStart(2, '0');
    const minute = this.tempNofiChild.minute.toString().padStart(2, '0');
    return `${hour}:${minute} ${this.tempNofiChild.period}`;
  }


  emailPreference: string = 'immediateEmail';
  getPreferenceDetails() {
    return this.preferenceMap[this.emailPreference] || 
           { label: 'Email Notification', severity: 'info' };
  }
  
  // formatTimeDisplay(): string {
  //   // Replace with actual time formatting logic
  //   return '9:00 AM';
  // }

  onEditClick() {

 this.displayEmailPreferenceDialog = true;
  }
  
  onDeleteClick() {
   
  }

  getSeverity() {
    return this.emailPreference === 'immediateEmail' ? 'info' : 'info';
  }

  openEmailPreferenceDialog() {
    this.displayEmailPreferenceDialog = true;
  }
}
